import { RootState } from '../types/redux/states/RootState';
import { makeUrl } from './makeUrl';
import { getRootDomain } from '../redux/selectors/getRootDomain';

export const makeAppUrl = (
  path: string,
  subDomain: string,
  queryParams: string[][] | Record<string, string> | string | URLSearchParams = {}
) => (getState: (() => RootState) | RootState): string => {
  const rootDomain = getRootDomain(typeof getState === 'function' ? getState() : getState);

  return makeUrl(`https://${subDomain}.${rootDomain}${path}`, queryParams);
};
